//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const EB1432NoAccessAlert: FeatureFlag = {"Id":"EB1432NoAccessAlert","Label":"(KILL)[10.26]EB1432NoAccessAlert","Impact":"DON'T TOUCH UNLESS DIRECTED BY A DEVELOPER. Kill switch for the fix to EB-1432. When active, a visitor whose access to a submission was fully revoked (e.g. reassigned away from their only Visitor Task) sees a \"You don't have access to this submission anymore.\" alert instead of a blank page. When disabled, the previous behavior is preserved (a blank page in that state).","Mode":3,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
